<template>
  <w-modal
    :value="value"
    width="448px"
    @close="onClose"
  >
    <h1 slot="header">啟用訪客訂購連結</h1>
    <div slot="content" class="content">
      <p class="mb-0">訪客連結開啟後，組織外人員即可參與「開放中」和「已截止」的訂購。</p>
      <p>訂購完成、取消或手動停用後，連結將自動失效。</p>
    </div>
    <div slot="footer">
      <w-button
        :disabled="isEnablingLink"
        type="link"
        @click="onClose"
      >
        取消
      </w-button>
      <w-button
        :disabled="isEnablingLink"
        :loading="isEnablingLink"
        class="ml-2"
        v-clipboard:copy="shareLink"
        v-clipboard:success="onCopySuccess"
        v-clipboard:error="onCopyError"
        @click="onEnableShareLink"
      >
        <span>啟用並複製訂購連結</span>
      </w-button>
    </div>
  </w-modal>
</template>

<script>
import EnableCustomLinkModal from './EnableCustomLinkModal';

export default EnableCustomLinkModal;
</script>
